import Header from '@/components/Header';
import ResetPassword from '@/components/ResetPassword';
import LargeContainer from '@/components/front-office/containers/LargeContainer';

const ResetPasswordPage = () => {
	return (
		<LargeContainer withImage={false}>
			<div>
				<Header
					heading="Réinitialisez votre mot de passe"
					paragraph="Vous avez déjà un compte ?"
					linkName="Connexion"
					linkUrl="/login"
				/>

				<ResetPassword />
			</div>
		</LargeContainer>
	);
};

export default ResetPasswordPage;
